module.exports = __webpack_public_path__ + "static/media/QualcommLogo.d5c7ca25.png";